































import Content from '@/components/common/Content.vue'
import { Component, Watch } from 'vue-property-decorator'
import Configuration from "@/components/products/framepuzzle/steps/ConfigurationImpl.vue"
import Design from "@/components/products/framepuzzle/design/DesignImpl.vue"
import Warning from "@/components/products/framepuzzle/FramePuzzleWarning.vue"
import FramePuzzleHeadline from "@/components/products/framepuzzle/FramePuzzleHeadline.vue"
import ProductPreview from "@/components/products/framepuzzle/design/ProductPreviewImpl.vue"
import { AppModule, Step } from "@/store/modules/app"
import CartButton from "@/components/products/framepuzzle/util/CartButton.vue"
import Gift from "@/components/products/framepuzzle/GiftImpl.vue"
import GiftOptionsButton from "@/components/products/framepuzzle/FramePuzzleGiftOptionsButton.vue"
import {
  FramePuzzleModule,
  ProductBoxes,
  PuzzleFormat,
  PuzzleBoxState,
  ProductPart
} from '../../../store/modules/framePuzzle';
import getCategories from '@/components/products/framepuzzle/util/categoryUtil'
import getDesigns from '@/components/products/framepuzzle/util/designUtil'
import Tab from '@/components/products/framepuzzle/Tab.vue'
import getImageRatios from '@/components/products/framepuzzle/util/imageRatioUtil'
import { getParts } from '@/components/products/framepuzzle/util/partsUtil'
import TagCommander from "@/components/common/TagCommander.vue"
import ShippingOverlay from "@/components/common/ShippingOverlay.vue"
import Impressum from '@/components/Impressum.vue'

interface PartPrice {
  [key: string]: number
}

interface SortParts {
  [key: string]: string
}

@Component({
  name: "frame-puzzle-content",
  components: {
    FramePuzzleHeadline,
    Design,
    Configuration,
    Warning,
    ProductPreview,
    CartButton,
    GiftOptionsButton,
    Gift,
    TagCommander,
    ShippingOverlay,
    Impressum
  }
})
export default class FramePuzzleContent extends Content {
  private showCartButton: boolean = false
  private puzzlePlaceholderStyle: string = "position: absolute; top: -7px; width: 300px; opacity: .4; left: 50px; z-index: 100; pointer-events: none; touch-action: none;"
  private initIsRunning = false

  get imageEditorWidth() {
    return FramePuzzleModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return FramePuzzleModule.imageEditorHeight
  }

  get showGiftOptions() {
    return AppModule.showGiftOptions
  }

  get availableCategories() {
    return FramePuzzleModule.availableCategories
  }

  get availableDesigns() {
    return FramePuzzleModule.availableDesigns
  }

  get parts() {
    return FramePuzzleModule.parts
  }

  get format() {
    return FramePuzzleModule.format
  }

  get resetFrameDesignToggled() {
    return FramePuzzleModule.resetFrameDesignToggled
  }

  get designsNotEmpty() {
    return FramePuzzleModule.designsNotEmpty
  }

  get stepsReseted() {
    return FramePuzzleModule.stepsReseted
  }

  get showMenu() {
    return AppModule.showMenu
  }

  get productId() {
    return AppModule.productID
  }

  @Watch('parts')
  partsChanged(newParts: string) {
    this.initCategories()
  }

  @Watch('resetFrameDesignToggled')
  resetFrameDesignToggledChanged(newResetFrameDesignToggled: boolean) {
    this.initCategories()
  }

  @Watch('stepsReseted')
  stepsResetedChanged(newStepsReseted: boolean) {
    this.initCategories()
    this.toggleFooterButton(false)
  }

  @Watch('productId')
  productIdChanged(newProductId: string) {
    (this.$refs.tagCommander as TagCommander).reload()
  }

  toggleFooterButton(state: boolean) {
    this.showCartButton = state
  }

  created() {
    this.initSteps()
    this.initProductName()
    this.initAvailableProducts()
    this.initCategories()
    this.initImageRatios()
    this.initAssets()
    this.$nextTick(() => {
      AppModule.SetActiveStep(0)
    });
    AppModule.SetHidePreviewButton(true)
  }

  initSteps(): void {
    AppModule.SET_STEPS([
      new Step(this.$t('stepOne').toString(), "puzzle-image-upload", false, 'frameimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0, 0]], this.$t('stepOneInfo').toString(), undefined, this.puzzlePlaceholderStyle),
      new Step(this.$t('stepTwo').toString(), "design-puzzle", false, 'frameimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0, 0]], this.$t('stepTwoInfo').toString(), undefined, this.puzzlePlaceholderStyle),
      new Step(this.$t('frameStepThree').toString(), "design-frame", false, 'frameimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0, 0]], this.$t('frameStepThreeInfo').toString())
    ])
  }

  initProductName(): void {
    if (!AppModule.productID) {
      AppModule.SetProductID("81556")
    }
    let parts = getParts(AppModule.productID)
    if (parts)
      FramePuzzleModule.SetParts(parts)
  }

  public initCategories(): void {
    if (!this.initIsRunning) {
      this.initIsRunning = true
      FramePuzzleModule.ClearCategories(true)
      FramePuzzleModule.ClearDesigns(true)
      FramePuzzleModule.ClearNotEmptyDesigns(true)
      getCategories().then(() => {
        let promises = []
        for (let i = 0; i < this.availableCategories.length; i++) {
          promises.push(getDesigns(this.availableCategories[i].id, this.parts, PuzzleFormat[this.format], "PAPER_BOX").then(() => {
            for (let k = 0; k < this.availableDesigns.length; k++) {
              if (this.availableDesigns[k].length !== 0) {
                let categoryId = Number(this.availableDesigns[k][0].designCategories)
                if (categoryId !== undefined && !this.designsNotEmpty.includes(categoryId)) {
                  FramePuzzleModule.SetDesignNotEmpty(categoryId)
                }
              }
            }
          }))
          promises.push(getDesigns(this.availableCategories[i].id, this.parts, PuzzleFormat[this.format], "METAL_BOX").then(() => {
            for (let k = 0; k < this.availableDesigns.length; k++) {
              if (this.availableDesigns[k].length !== 0) {
                let categoryId = Number(this.availableDesigns[k][0].designCategories)
                if (categoryId !== undefined && !this.designsNotEmpty.includes(categoryId)) {
                  FramePuzzleModule.SetDesignNotEmpty(categoryId)
                }
              }
            }
          }))
        }
        Promise.all(promises).then(() => {
          this.initDesignNr()
          this.initIsRunning = false
        })
      })
    }
  }

  sortList(list: any[]) {
    return list.sort((a, b) => {
      return a.sort! - b.sort!;
    });
  }

  initDesignNr(): void {
    let minSort = -1
    let idWithMinSort = -1
    let designs = []
    for (let i = 0; i < this.availableCategories.length; i++) {
      let currentId = this.availableCategories[i].id
      if (currentId !== undefined) {
        if (this.designsNotEmpty.includes(currentId)) {
          let currentSort = this.availableCategories[i].sort
          if (currentSort !== undefined) {
            if (minSort === -1) {
              minSort = currentSort
              idWithMinSort = currentId
            }
            if (currentSort < minSort) {
              minSort = currentSort
              idWithMinSort = currentId
            }
          }
        }
      }
    }
    for (let j = 0; j < this.availableDesigns.length; j++) {
      if (this.availableDesigns[j].length !== 0) {
        let categoryId = Number(this.availableDesigns[j][0].designCategories)
        let currentBox = this.availableDesigns[j][0].boxType
        if (categoryId === idWithMinSort && currentBox === 'PAPER_BOX') {
          for (let k = 0; k < this.availableDesigns[j].length; k++) {
            let online = this.availableDesigns[j][k].online
            if (online) {
              designs.push(this.availableDesigns[j][k])
            }
          }
        }
      }
    }
    designs = this.sortList(designs)
    if (designs[0].designNr !== undefined) {
      FramePuzzleModule.SetBoxDesign(designs[0].designNr)
    }
  }

  initAvailableProducts() {
    let products: ProductPart[] = []
    let boxes: ProductBoxes[] = []
    const partPrice: PartPrice = {}
    if (AppModule.session.products !== undefined) {
      const sortParts: SortParts = {};
      for (let i = 0; i < AppModule.session.products.length; i++) {
        const product = AppModule.session.products[i]

        if (product.parts !== undefined) {
          partPrice[product.parts] = partPrice[product.parts] || 99999;
          if (product.price !== undefined && product.price.price != null && product.price.price < partPrice[product.parts]) {
            partPrice[product.parts] = product.price.price
          }

          // cleanup the parts that we can sort them by pieces. 45 is the one piece puzzle
          const partClean = product.parts.replace(/[^\d]+/g, '').replace(/^45$/, '1');
          sortParts[partClean] = product.parts
        }
      }
      const partKeys: string[] = Object.keys(sortParts).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      for (const partKey in partKeys) {
        const part = sortParts[partKeys[partKey]];
        products.push({
          part: part,
          price: (this.$options.filters !== undefined) ? this.$options.filters.currency(partPrice[part], this.currencySymbol, 2, this.currencyFilterOptions) : 0
        })
        boxes.push({ parts: part, boxes: [false, false] })
      }

      //filling boxTypes
      for (let k = 0; k < AppModule.session.products.length; k++) {
        let currentParts = AppModule.session.products[k].parts
        let positionInBoxes = -1
        for (let j = 0; j < boxes.length; j++) {
          if (currentParts === boxes[j].parts) {
            if (AppModule.session.products[k].boxType === "PAPER_BOX") {
              boxes[j].boxes[0] = true
            }
          }
        }
      }
    }
    FramePuzzleModule.SetAvailableParts(products)
    FramePuzzleModule.SetAvailableBoxes(boxes)
  }

  initImageRatios() {
    getImageRatios()
  }

}
